import React, { useState } from "react";
import { ReactComponent as PendingIcon } from "../../../Assets/Icons/pendingIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../Assets/Icons/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../Assets/Icons/editSvg.svg";
import { ReactComponent as MapIcon } from "../../../Assets/Icons/MapIcon.svg";
import { ReactComponent as MailIcon } from "../../../Assets/Icons/mailIcon.svg";
import { ReactComponent as GenderIcon } from "../../../Assets/Icons/gender.svg";
import { ReactComponent as AgeIcon } from "../../../Assets/Icons/ageIcon.svg";
import { ReactComponent as PhoneIcon } from "../../../Assets/Icons/phoneIcon.svg";
import { ReactComponent as CurrencyIcon } from "../../../Assets/Icons/currency.svg";
import { ReactComponent as CalendarIcon } from "../../../Assets/Icons/Calender.svg";
import "../../common/OfferList/offerList.scss";
import profileImage from "../../../Assets/Images/Ellipse 3.svg";
import PrimaryButton from "../../common/PrimaryButton";
import PrimaryOutlineButton from "../../common/PrimaryOutlineButton";
import { bulkStatusUpdate } from "../../../services/fundraiserService";
import { useDispatch } from "react-redux";
import DetailsModal from "../../common/DetailsModal";
import RedeemedOffers from "./RedeemedOffers";

const PopupContent = ({ userDetails, onRedeemedOfferClick }) => {
  const dispatch = useDispatch();
  const [statusToggled, setStatusToggled] = useState(false);
  // Remove offerDetailsOpen and offerDetails state

  const {
    age,
    email,
    gender,
    image,
    phone,
    name,
    redeemedOffers,
    _id,
    status,
    subscriptionStatus,
    subscriptionAmount,
    referredBy,
    createdAt,
  } = userDetails;

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "N/A";
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "N/A";
    }
  };

  // Remove closePopup and openPopup

  // Mock data for redeemed offers - replace with actual data
  // const redeemedOffers = [
  //   {
  //     id: 1,
  //     brand: "McDonalds",
  //     logo: "https://via.placeholder.com/40x40/FFD700/000000?text=M",
  //     address: "65 Mt Berryman Road",
  //     count: 8,
  //   },
  //   {
  //     id: 2,
  //     brand: "McDonalds",
  //     logo: "https://via.placeholder.com/40x40/FFD700/000000?text=M",
  //     address: "65 Mt Berryman Road",
  //     count: 3,
  //   },
  //   {
  //     id: 3,
  //     brand: "KFC",
  //     logo: "https://via.placeholder.com/40x40/DC143C/FFFFFF?text=KFC",
  //     address: "65 Mt Berryman Road",
  //     count: 5,
  //   },
  //   {
  //     id: 4,
  //     brand: "Burger King",
  //     logo: "https://via.placeholder.com/40x40/FF4500/FFFFFF?text=BK",
  //     address: "65 Mt Berryman Road",
  //     count: 4,
  //   },
  //   {
  //     id: 5,
  //     brand: "Pizza Hut",
  //     logo: "https://via.placeholder.com/40x40/FF0000/FFFFFF?text=PH",
  //     address: "65 Mt Berryman Road",
  //     count: 2,
  //   },
  // ];

  const handleBulkApprove = async (fundraiserId) => {
    console.log("Approving fundraisers:", fundraiserId);
    const payload = {
      fundraiserIds: [fundraiserId],
      status: "approved",
    };
    const statusPromise = await dispatch(bulkStatusUpdate(payload))?.unwrap();
    if (statusPromise?.success === true) {
      setStatusToggled(!statusToggled);
    }
  };

  const handleBulkDecline = async (fundraiserId) => {
    console.log("Declining fundraisers:", fundraiserId);
    const payload = {
      fundraiserIds: [fundraiserId],
      status: "declined",
    };
    const statusPromise = await dispatch(bulkStatusUpdate(payload))?.unwrap();
    if (statusPromise?.success === true) {
      setStatusToggled(!statusToggled);
    }
  };

  return (
    <div
      style={{ scrollbarWidth: "none" }}
      className="max-h-[600px] overflow-y-auto w-full flex flex-col gap-4 font-poppins bg-white p-6 rounded-lg z-index-60"
    >
      {/* Header Section with Avatar and Status */}
      <div className="flex justify-between items-start mb-6">
        <div className="flex items-center gap-6">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-semibold text-lg">
            {/* {image && (
          <img
            src={process.env.REACT_APP_S3_URL + image}
            className="w-[93px] h-[93px] object-contain rounded-full"
          />
        )} */}
            {name
              ? name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")
                  .toUpperCase()
              : "JS"}
          </div>
          <div className="flex flex-col items-start text-left leading-tight">
            <h1 className="font-semibold text-lg text-gray-900">
              {name || "John Smith"}
            </h1>
            <p className="text-sm text-gray-500">
              {email || "jsmith@email.com"}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span
            className={`px-3 py-1 rounded-full text-xs font-medium border-[0.5px] ${
              subscriptionStatus
                ? "bg-[#50CD8933] text-[#303033] border-[#50CD89]"
                : "bg-[#BABABA33] text-[#303033] border-[#B1B1B1]"
            }`}
          >
            {subscriptionStatus ? "Active" : "Inactive"}
          </span>
        </div>
      </div>

      {/* User Details Grid */}
      <div className="grid grid-cols-3 gap-y-5 gap-x-4 mb-2 items-center">
        <div className="flex items-center gap-3 text-[14px] text-[#767676]">
          <AgeIcon />
          <span className="text-xs">{age || "N/A"}</span>
        </div>
        <div className="flex items-center gap-3 text-[14px] text-[#767676]">
          <PhoneIcon />
          <span className="text-xs">{phone || "N/A"}</span>
        </div>
        <div className="flex items-center gap-3 text-[14px] text-[#767676] ml-8">
          <CalendarIcon />
          <span className="text-xs">{createdAt ? formatDate(createdAt) : "N/A"}</span>
        </div>
        <div className="flex items-center gap-3 text-[14px] text-[#767676]">
          <GenderIcon />
          <span className="text-xs">{gender || "N/A"}</span>
        </div>
        <div className="flex items-center gap-3 text-[14px] text-[#767676]">
          <CurrencyIcon />
          <span className="text-xs">{subscriptionAmount ? `$${subscriptionAmount}` : "$0"}</span>
        </div>
        {referredBy ? (
          <div className="flex items-center gap-3 text-[14px] text-[#767676] ml-8">
            {referredBy?.fundraiserLogo ? (
              <img 
                src={process.env.REACT_APP_S3_URL + referredBy?.fundraiserLogo} 
                className="w-6 h-6 object-contain rounded-full" 
                alt="Fundraiser Logo"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            ) : (
              <div className="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center">
                <span className="text-xs text-gray-500">?</span>
              </div>
            )}
            <span className="text-xs truncate max-w-[100px]" title={referredBy?.name}>
              {referredBy?.name || 'Unknown Fundraiser'}
            </span>
          </div>
        ) : (
          <div></div>
        )}
      </div>
      {userDetails.address && (
        <div className="flex items-center gap-3 text-[14px] text-[#767676] mb-4">
          <MapIcon className="w-4 h-4 text-gray-400" />
          <span className="text-xs">{userDetails.address}</span>
        </div>
      )}

      {/* Redeemed Offers Section */}
      {redeemedOffers?.length > 0 && (
        <>
          <h2 className="text-[16px] font-[500] text-[#000000] text-start">
            Redeemed Offers
          </h2>
          <div
            className="border border-[#00000029] rounded-[12px] p-4 max-h-[400px] overflow-y-auto"
            style={{ scrollbarWidth: "none" }}
          >
            {/* Group offers into rows of 2 */}
            {Array.from({ length: Math.ceil(redeemedOffers.length / 2) }).map((_, rowIdx) => {
              const startIdx = rowIdx * 2;
              const rowOffers = redeemedOffers.slice(startIdx, startIdx + 2);
              const isLastRow = rowIdx === Math.ceil(redeemedOffers.length / 2) - 1;
              return (
                <div
                  key={rowIdx}
                  className={`grid grid-cols-2 gap-3 ${!isLastRow ? 'border-b border-b-[#00000014] mb-2' : ''}`}
                >
                  {rowOffers.map((offer, colIdx) => (
                    <div
                      key={colIdx}
                      className="flex items-start justify-between p-1 cursor-pointer"
                      onClick={() => onRedeemedOfferClick && onRedeemedOfferClick(offer)}
                    >
                      <div className="flex items-center gap-3">
                        <img
                          src={
                            offer?.merchant?.logo
                              ? process.env.REACT_APP_S3_URL +
                                offer?.merchant?.logo
                              : profileImage
                          }
                          alt={"Brand"}
                          className="w-11 h-11 rounded-lg object-cover"
                        />
                        <div className="flex flex-col justify-start items-start">
                          <p className="font-medium text-gray-900 text-sm">
                            {offer?.merchant?.businessName}
                          </p>
                          <p className="text-xs text-gray-500 text-left">
                            {offer?.merchant?.address}
                          </p>
                        </div>
                      </div>
                      <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center">
                        <span className="text-blue-600 text-xs font-semibold">
                          {offer?.offers?.length}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* Action Buttons */}
      {status === "pending" && (
        <div className="flex justify-center items-center gap-4 mt-6 pt-4 border-t">
          <PrimaryOutlineButton
            label={"Decline"}
            className={
              "w-32 !font-nunito text-sm font-bold px-4 !h-10 rounded-md"
            }
            onClick={() => handleBulkDecline(_id)}
          />
          <PrimaryButton
            className={"w-32 !h-10 rounded-md text-sm font-bold !font-nunito"}
            label="Approve"
            onClick={() => handleBulkApprove(_id)}
          />
        </div>
      )}
    </div>
  );
};

export default PopupContent;
